module.exports = __webpack_public_path__ + "afd7eb5cf6cd3cc9e22b24f71ec5c8ef.png";